import React from "react";
import PropTypes from "prop-types";
import { SwitchButton } from "@learningblocks/shared-components";
import cname from "../WidgetStyles";

/**
 * SwitchButtonBlock:
 *  - Display and manage all SwitchButtons associalted with the widget
 */
export function SwitchButtonBlock(props) {
  const onToggleSwitch =
    ({ name, value }) =>
    (checked) =>
      props.onToggleSwitch({ name, value, checked });

  const renderSwitch = (comp) => (
    <div key={comp.value} className={cname.switch}>
      <SwitchButton
        className={cname.button}
        value={comp.value}
        checked={comp.checked}
        name={comp.name}
        label={comp.label}
        onChange={onToggleSwitch(comp)}
        ariaLabel={comp.ariaLabel}
      />
    </div>
  );

  return (
    <div className={cname.switchBlock}>
      {props.switchButtons.map(renderSwitch)}
    </div>
  );
}

SwitchButtonBlock.propTypes = {
  /**
   * List of Switch Buttons to render
   */
  switchButtons: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * name of switch button
       */
      name: PropTypes.string,
      /**
       * value of switch button
       */
      value: PropTypes.string,
      /**
       * Boolean for checked propperty
       */
      checked: PropTypes.bool,
      /**
       * Label for the Switch option
       */
      label: PropTypes.string,
      /**
       * aria-label (alt table)
       */
      ariaLabel: PropTypes.string,
    })
  ),
  /**
   * Callback for onChange method of Switch
   */
  onToggleSwitch: PropTypes.func,
};

SwitchButtonBlock.deafultProps = {
  switchButtons: [],
};
